import { useCarouselContext } from '@upright/ui/common/upright/core/impact-lens-profile/context';

export function EmptyState() {
  const { lens } = useCarouselContext();
  if (!lens.EmptyState) {
    return <></>;
  }
  return <lens.EmptyState />;
}
